import http from "./httpService";

export function createtag(name) {
  return http.post(`${process.env.REACT_APP_API}/tags`, {
    name: name,
  });
}
